<template>
  <div class="app-container">
    <div class="top_tab flex_center_between">
      <div @click="branchTmp('my')"
           class="notActive">
        我的
      </div>
      <div @click="branchTmp('stu')"
           v-if="userInfo.branchList.length > 0"
           class="notActive">学生</div>
      <div class="active">教职工</div>
      <div @click="branchTmp('dorm')"
           v-if="userInfo.branchList.length > 0"
           class="notActive">住宿生</div>
    </div>
    <div class="flex_center_around bg-fff  top_handle"
         :class="{'boxShadow_none': userInfo.branchList.length > 0,'van-dropdown-menu__bar':userInfo.branchList.length === 0 }">
      <span v-if="userInfo.branchListTeacher.length === 1"
            class="schoolName">{{userInfo.branchListTeacher[0].branchName}}</span>
      <span v-if="userInfo.branchListTeacher.length > 1"
            class="schoolName">{{userInfo.schoolName}}</span>
      <van-dropdown-menu>
        <van-dropdown-item :title="currentDay"
                           @open="openDate"
                           ref="datePicker">
          <van-datetime-picker v-model="date"
                               type="date"
                               :max-date="maxDate"
                               @confirm="selectDate"
                               @cancel="cancelDate"
                               title="请选择年月日" />
        </van-dropdown-item>
        <van-dropdown-item :title="timeName"
                           ref="timePicker">
          <van-picker title="请选择时段"
                      value-key='periodName'
                      ref="periodName"
                      show-toolbar
                      :default-index="timeIndex"
                      :columns="timeList"
                      @confirm="selectTime"
                      @cancel="cancelTime" />
        </van-dropdown-item>
      </van-dropdown-menu>
    </div>
    <div class="content"
         :class="{'withTabHeight': userInfo.branchList.length > 0}">
      <div class="title fontBold">
        <span>部门考勤数据</span>
        <span class="fontSize14">{{ timeName && periodBeginTime &&  periodEndTime ? '（' + timeName + '：'  + periodBeginTime + '~' + periodEndTime + '）' : ''}}</span>
      </div>
      <div class="data fontSize14 marginTop5 fontBold text_c">
        <van-row>
          <van-col span="6">部门人数</van-col>
          <van-col span="6">&nbsp;时段</van-col>
          <van-col span="6">&nbsp;已考勤</van-col>
          <van-col span="6">&nbsp;未考勤</van-col>
        </van-row>
        <van-row class="marginTop5">
          <van-col span="6">
            <div class="marginTop20"> {{gradeStduentCount}}</div>
          </van-col>
          <van-col span="6">
            <div class="marginTop5">&nbsp;上班</div>
            <div class="marginTop10">&nbsp;下班</div>
          </van-col>

          <van-col span="6">
            <div class="marginTop5">&nbsp;{{workCount}}</div>

            <div class="marginTop10">&nbsp;{{endCount}}</div>
          </van-col>
          <van-col span="6">
            <div class="marginTop5">&nbsp;{{noWorkCount}}</div>
            <div class="marginTop10">&nbsp;{{noEndCount}}</div>
          </van-col>
        </van-row>
      </div>
      <div class="title marginTop10 fontBold">
        <span>
          {{userInfo.branchListTeacher.length > 1 ? '各部门详细数据' : '详细数据'}}
        </span>
      </div>
      <div class="table fontSize14 text_c marginTop5"
           ref="table">
        <van-row class="fontBold marginBottom5 paddingRight16"
                 v-if="userInfo.branchListTeacher.length > 1 ">
          <van-col span="3">序号</van-col>
          <van-col span="4">部门</van-col>
          <van-col span="3">人数</van-col>
          <van-col span="7">上班已/未考勤</van-col>
          <van-col span="7">下班已/未考勤</van-col>
        </van-row>
        <div v-if="userInfo.branchListTeacher.length > 1 "
             class="resultTable"
             ref="resultTable">
          <div v-if="temperatureList.length > 0">
            <van-collapse v-model="activeCollapse"
                          accordion>
              <van-collapse-item :name="String(index + 1)"
                                 v-for="(item,index) in temperatureList">
                <template #title>
                  <van-row class="fontBold">
                    <van-col span="3">{{index + 1}}</van-col>
                    <van-col span="4">{{item.branchName}}</van-col>
                    <van-col span="3">{{item.classStudentCount}}</van-col>
                    <van-col span="7">{{item.workCount + '/' + item.noWorkCount}}</van-col>
                    <van-col span="7">{{item.endCount + '/' + item.noEndCount}}</van-col>
                  </van-row>
                </template>
                <div class="fontColor00">
                  <!-- <van-sticky :container="stickyContainer"> -->
                  <van-row class="marginBottom5 fontBold classTitle">
                    <van-col span="6">序号</van-col>
                    <van-col span="6">员工姓名</van-col>
                    <van-col span="6">上班时间</van-col>
                    <van-col span="6">下班时间</van-col>
                  </van-row>
                  <!-- </van-sticky> -->
                  <div v-if="item.students.length === 0">
                    暂无数据
                  </div>
                  <div v-if="item.students.length > 0">
                    <van-row v-for="(_item,_index) in item.students"
                             class="marginBottom5">
                      <van-col span="6">{{_index + 1}}</van-col>
                      <van-col span="6">{{_item.studentName}}</van-col>
                      <van-col span="6">{{ _item.attendanceNewDate ? _item.attendanceNewDate : '--' }}</van-col>

                      <van-col span="6">{{_item.attendanceDate ? _item.attendanceDate : '--'}}</van-col>
                    </van-row>
                  </div>
                </div>
              </van-collapse-item>
            </van-collapse>
          </div>

        </div>
        <div v-if="userInfo.branchListTeacher.length === 1 "
             class="resultTable">
          <van-row class="marginBottom5 fontBold classTitle">
            <van-col span="6">序号</van-col>
            <van-col span="6">员工姓名</van-col>
            <van-col span="6">上班时间</van-col>
            <van-col span="6">下班时间</van-col>
          </van-row>
          <div class="bg-fff branchList"
               v-if="temperatureList.length > 0 ">
            <van-row v-for="(item,index) in temperatureList"
                     :class="{'marginBottom5': index !== temperatureList.length - 1 }">
              <van-col span="6">{{index + 1}}</van-col>
              <van-col span="6">{{item.studentName}}</van-col>
              <van-col span="6">{{item.attendanceNewDate ? item.attendanceNewDate : '--'}}</van-col>
              <van-col span="6">{{item.attendanceDate ? item.attendanceDate : '--'}}</van-col>
            </van-row>
          </div>
        </div>
        <div v-if="temperatureList.length === 0"
             class="bg-fff branchList">
          暂无数据
        </div>
      </div>
      <loading :loading="isLoading"></loading>
      <floatBtn @onFloatBtnClicked="abnormalTmp"
                :isImg="true"
                :img="abnormalImg"></floatBtn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { parseTime } from '@/utils/index'
import { getBranchStatCard, getBranchShiftPeriodList } from '@/api'
import loading from '@/components/loading'
import floatBtn from '@/components/floatBtn'
export default {
  computed: {
    ...mapGetters(['userInfo'])
  },
  components: { loading, floatBtn },
  data () {
    return {
      currentDay: '',
      date: new Date(),
      maxDate: new Date(),
      timeId: '',
      timeName: '',
      timeList: [],
      gradeIndex: 0,
      timeIndex: 0,
      temperatureList: [], // 测温表格
      periodBeginTime: '',
      periodEndTime: '',
      gradeStduentCount: 0,
      noAttendStudentCount: 0,
      attendStudentCount: 0,
      endCount: 0,
      workCount: 0,
      noEndCount: 0,
      noWorkCount: 0,
      exceptionStudentCount: 0,
      activeCollapse: '1',
      isLoading: true,
      abnormalImg: '',
      stickyContainer: null
    }
  },
  created () {
    // 默认当天日期
    this.currentDay = parseTime(this.date, '{y}-{m}-{d}')
    this.getBranchShiftPeriodList()
  },
  methods: {
    // 获取年级所在时段
    getBranchShiftPeriodList () {
      getBranchShiftPeriodList({
        branchId: this.userInfo.branchListTeacher[0].branchId,
        date: this.currentDay
      })
        .then(res => {
          if (res.code === 200) {
            this.timeList = []
            if (res && res.data.length > 0) {
              this.timeList = res.data
              // 默认展示第一个时段的数据
              this.timeIndex = 0
              this.timeName = this.timeList[0].periodName
              this.getBranchStatCard()
            } else {
              this.handleEmpty()
            }
          } else {
            this.timeList = []
            this.timeName = ''
            this.periodBeginTime = ''
            this.periodEndTime = ''
            this.handleEmpty()
          }
        })
        .catch(err => {
          this.timeList = []
          this.timeName = ''
          this.periodBeginTime = ''
          this.periodEndTime = ''
          this.handleEmpty()
          this.isLoading = false
        })
    },
    // 无数据处理
    handleEmpty () {
      this.abnormalImg = require('../../assets/img/normal.png')
      this.temperatureList = []
      this.gradeStduentCount = 0
      this.attendStudentCount = 0
      this.noAttendStudentCount = 0
      this.endCount = 0
      this.workCount = 0
      this.noEndCount = 0
      this.noWorkCount = 0
      this.exceptionStudentCount = 0

      this.exceptionStudentCount = 0
      this.isLoading = false
    },
    openDate () {
      this.date = new Date(this.currentDay)
    },
    // 选择日期
    selectDate (value) {
      this.currentDay = parseTime(value, '{y}-{m}-{d}')
      this.$refs.datePicker.toggle()
      // this.getBranchStatCard()
      this.getBranchShiftPeriodList()
    },
    cancelDate () {
      this.$refs.datePicker.toggle()
    },
    // 选择时段
    selectTime (value, index) {
      this.timeIndex = index
      this.timeName = value.periodName
      this.$refs.timePicker.toggle()
      this.getBranchStatCard()
    },
    cancelTime () {
      this.$refs.periodName.setIndexes([this.timeIndex])
      this.$refs.timePicker.toggle()
    },

    // 获取部门当日时段员工考勤数据
    getBranchStatCard () {
      this.isLoading = true
      const periodTime = this.timeList.filter(item => {
        return item.periodName === this.timeName
      })
      this.periodBeginTime = periodTime[0].periodBeginTime
      this.periodEndTime = periodTime[0].periodEndTime
      getBranchStatCard(
        this.userInfo.branchListTeacher.map(item => {
          return item.branchId
        }),
        {
          periodBeginDate: this.currentDay + ' ' + this.periodBeginTime,
          periodEndDate: this.currentDay + ' ' + this.periodEndTime
          //   periodBeginDate: '2021-01-01 08:00',
          //   periodEndDate: '2025-08-28 18:00'
        }
      )
        .then(res => {
          if (res.code === 200) {
            if (res.data) {
              this.gradeStduentCount = res.data.gradeStduentCount
              //   this.attendStudentCount = res.data.gradeAttendStduentCount
              //   this.noAttendStudentCount = res.data.gradeNoAttendStduentCount
              this.workCount = 0
              this.endCount = 0
              this.noEndCount = 0
              this.noWorkCount = 0
              this.exceptionStudentCount = res.data.gradeException.length
              if (this.exceptionStudentCount === 0) {
                this.abnormalImg = require('../../assets/img/normal.png')
              } else {
                this.abnormalImg = require('../../assets/img/abnormal.png')
              }
              res.data.listClass.forEach(item => {
                item.workCount = 0
                item.endCount = 0
                item.noEndCount = 0
                item.noWorkCount = 0
                item.students.forEach(_item => {
                  if (_item.attendanceNewDate == _item.attendanceDate) {
                    _item.attendanceDate = null
                  }
                  if (_item.attendanceNewDate) {
                    item.workCount++
                  }
                  if (_item.attendanceDate) {
                    item.endCount++
                  }
                })
                item.noEndCount = item.students.length - item.endCount
                item.noWorkCount = item.students.length - item.workCount
                this.workCount += item.workCount
                this.endCount += item.endCount
              })
              this.noEndCount = this.gradeStduentCount - this.endCount
              this.noWorkCount = this.gradeStduentCount - this.workCount
              if (this.userInfo.branchListTeacher.length > 1) {
                this.temperatureList = res.data.listClass
              } else {
                this.temperatureList = res.data.listClass[0].students
              }
            }
            this.isLoading = false
          } else {
            this.handleEmpty()
          }
        })
        .catch(err => {
          this.handleEmpty()
        })
    },
    // 异常体温
    abnormalTmp () {
      this.$router.push('/abnormalTemperature')
    },
    // 学生体温
    branchTmp (type) {
      if (type === 'my') {
        this.$router.push('/my')
      } else {
        if (this.userInfo.roleFlag === 'CLASS') {
          // 班级
          this.$router.push(
            type === 'stu' ? '/classTemperature' : '/classDormTemperature'
          )
        } else if (this.userInfo.roleFlag === 'GRADE') {
          // 年级
          this.$router.push(
            type === 'stu' ? '/gradeTemperature' : '/gradeDormTemperature'
          )
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.app-container {
  background-color: #eff5fd;
  ::v-deep .van-picker__confirm,
  ::v-deep .van-dropdown-menu__title--active {
    color: #ee0a24;
  }
  .branchList {
    padding: 15px 5px;
    border-radius: 5px;
  }
  .top_handle {
    span {
      font-size: 14px;
    }

    ::v-deep .van-dropdown-menu {
      width: 66.66%;
    }
    ::v-deep .van-dropdown-menu__bar {
      box-shadow: unset;
    }
  }
  ::v-deep .van-popup--top {
    bottom: 0;
    top: unset;
  }
  ::v-deep .van-col {
    height: 100%;
  }
  .withTabHeight {
    height: calc(100% - 72px) !important;
  }
  .content {
    padding: 10px;
    height: calc(100% - 50px);
    .title {
      height: 30px;
      line-height: 30px;
      span:nth-child(1) {
        color: rgb(5, 182, 252);
      }
    }
    .data,
    .table {
      line-height: 20px;
      background: #cce3ff;
      border-radius: 5px;
    }
    .data {
      padding: 10px;
    }
    .table {
      padding: 10px 5px;
      max-height: calc(100% - 140px);
      display: flex;
      flex-flow: column;
      overflow: hidden;
      .resultTable {
        flex: 1;
        overflow-y: auto;
        border-radius: 5px;
      }
      .paddingRight16 {
        padding-right: 16px;
      }
      ::v-deep .van-collapse-item {
        .van-cell {
          padding: 10px 0;
          // background: #dfebfb;
        }
        .van-cell--clickable {
          cursor: pointer;
          position: sticky;
          top: -1px;
          z-index: 9;
          // top: 64px;
          // z-index: 99;
        }

        .van-collapse-item__content {
          // background: #dfebfb;
          padding: 10px 0;
          // position: relative;
        }
      }
      // font-size: 12px;
    }
  }
}
</style>